/**
 * Módulo: Stock UI Index - Entry Point
 * Arquivo: js/pages/suprimentos/estoque/index.js
 * 
 * Orquestra todos os componentes da UI do estoque
 * Substitui completamente o antigo estoque.js
 */

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.suprimentos = window.FazendaRP.Pages.suprimentos || {};

window.FazendaRP.Pages.suprimentos.estoque = {
    data: [],
    catalogMap: [],
    selectedItem: null,

    /**
     * Renderiza página principal do estoque
     */
    render: async function (container) {
        container.innerHTML = `
            <div id="estoque-dashboard" style="display: flex; flex-direction: column; gap: 20px; height: calc(100vh - 140px);">
                
                <!-- 1. KPI HEADER -->
                <div style="display: flex; gap: 20px; height: 110px;">
                    
                    <!-- DIESEL S500 CARD -->
                    <div class="card" style="flex: 1; padding: 20px; display: flex; align-items: center; justify-content: space-between; border-left: 5px solid #10b981;">
                        <div>
                            <div style="color: #6b7280; font-size: 0.9rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">Diesel S500 (Tanque)</div>
                            <div id="kpi-diesel-qty" style="font-size: 2.2rem; font-weight: 700; color: #111827; margin-top: 5px;">- L</div>
                            <div style="color: #6b7280; font-size: 0.8rem;">Disponível para uso</div>
                        </div>
                        <div style="text-align: right;">
                            <div style="width: 150px; height: 15px; background: #e5e7eb; border-radius: 10px; overflow: hidden; margin-bottom: 5px;">
                                <div id="kpi-diesel-bar" style="width: 0%; height: 100%; background: #10b981; transition: width 1s;"></div>
                            </div>
                            <small style="color: #9ca3af;">Capacidade: ~5.000L</small>
                        </div>
                    </div>

                    <!-- CAPITAL CARD -->
                    <div class="card" style="flex: 1; padding: 20px; display: flex; align-items: center; justify-content: space-between; border-left: 5px solid #2563eb;">
                        <div>
                            <div style="color: #6b7280; font-size: 0.9rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">Capital Total em Estoque</div>
                            <div id="kpi-total-value" style="font-size: 2.2rem; font-weight: 700; color: #111827; margin-top: 5px;">R$ -</div>
                            <div style="color: #6b7280; font-size: 0.8rem;">Valor financeiro auditado</div>
                        </div>
                        <div style="background: #eff6ff; width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                            <i class="fas fa-coins fa-2x" style="color: #2563eb;"></i>
                        </div>
                    </div>

                    <!-- ALERTS CARD -->
                    <div id="card-alerts" class="card" style="flex: 0 0 200px; padding: 20px; display: none; align-items: center; justify-content: center; border-left: 5px solid #ef4444; background: #fef2f2;">
                        <div style="text-align: center;">
                            <div style="font-size: 1.5rem; font-weight: 700; color: #b91c1c;" id="alert-count">0</div>
                            <small style="color: #b91c1c; font-weight:600;">Itens com Problemas</small>
                        </div>
                    </div>

                </div>

                <!-- 2. TOOLBAR + TABLE -->
                <div class="card" style="flex: 1; display: flex; flex-direction: column; padding: 0; overflow: hidden; border: 1px solid #e5e7eb; box-shadow: none;">
                    
                    <!-- Toolbar -->
                    <div style="padding: 10px 20px; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: space-between; background: #fff;">
                        <div style="display: flex; align-items: center; gap: 15px; flex: 1;">
                            <i class="fas fa-list" style="color: #4b5563;"></i>
                            <h3 style="margin: 0; font-size: 1.1rem; font-weight: 600; color: #111827;">Conferência de Itens</h3>
                            
                            <!-- Search -->
                            <div style="position: relative; margin-left: 20px;">
                                <i class="fas fa-search" style="position: absolute; left: 10px; top: 9px; color: #9ca3af;"></i>
                                <input type="text" id="estoque-search" placeholder="Buscar item..." style="padding: 6px 10px 6px 35px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem; width: 300px; background: #f9fafb;">
                            </div>

                            <!-- Category Filter -->
                            <select id="sel-filter-category" style="padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem; background: #f9fafb; color: #374151; max-width: 200px;">
                                <option value="">Todas as Categorias</option>
                            </select>
                        </div>

                        <div style="display: flex; align-items: center; gap: 15px;">
                            <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 0.9rem; color: #374151;">
                                <input type="checkbox" id="chk-hide-zero" style="cursor: pointer;" checked>
                                Ocultar Sem Estoque
                            </label>

                            <button id="btn-ajuste-manual" class="btn" style="background: #10b981; color: white; border: none; padding: 6px 15px; border-radius: 6px; font-weight: 500; display: flex; align-items: center; gap: 8px;">
                                <i class="fas fa-pen-to-square"></i> Ajuste Manual
                            </button>
                        </div>
                    </div>

                    <!-- Table -->
                    <div style="flex: 1; overflow-y: auto;">
                        <table style="width: 100%; border-collapse: collapse; text-align: left;">
                            <thead style="background: #f9fafb; position: sticky; top: 0; z-index: 10; border-bottom: 1px solid #e5e7eb;">
                                <tr>
                                    <th style="padding: 8px 15px; font-size: 0.75rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Item / Descrição</th>
                                    <th style="padding: 8px 15px; font-size: 0.75rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Categoria</th>
                                    <th style="padding: 8px 15px; font-size: 0.75rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; text-align: center;">Unidade</th>
                                    <th style="padding: 8px 15px; font-size: 0.75rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; text-align: right;">Quantidade Atual</th>
                                    <th style="padding: 8px 15px; font-size: 0.75rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; text-align: right;">Custo Médio</th>
                                    <th style="padding: 8px 15px; font-size: 0.75rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; text-align: right;">Valor Total</th>
                                    <th style="padding: 8px 15px; text-align: center; width: 60px;"></th>
                                </tr>
                            </thead>
                            <tbody id="estoque-table-body">
                                <tr><td colspan="7" style="padding: 40px; text-align: center; color: #9ca3af;"><i class="fas fa-spinner fa-spin"></i> Carregando dados...</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        `;

        // Render modals
        this.renderTimelineModal();
        this.renderAjusteModal();

        // Load data
        await this.loadEstoque();

        // Setup listeners
        this.setupListeners();
    },

    /**
     * Carrega dados do estoque
     */
    loadEstoque: async function () {
        try {
            // Buscar estoque
            const { data: stockData, error: stockError } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('*')
                .order('item_nome');

            if (stockError) throw stockError;

            // Buscar catálogo para categorias
            const { data: catalogData } = await window.FazendaRP.supabase
                .from('suprimentos_itens')
                .select('id, nome, parent_id, tipo');

            this.catalogMap = catalogData || [];
            this.data = (stockData || []).map(item => ({
                ...item,
                categoria: this.resolveCategory(item.item_id, item.item_nome, this.catalogMap)
            }));

            this.updateKPIs();
            this.renderTable(this.data);
            this.populateCategoryFilter();

        } catch (err) {
            console.error('Erro ao carregar estoque:', err);
            const tbody = document.getElementById('estoque-table-body');
            if (tbody) tbody.innerHTML = `<tr><td colspan="7" style="color:red; text-align:center; padding:20px;">Erro: ${err.message}</td></tr>`;
        }
    },

    /**
     * Resolve categoria de um item
     */
    resolveCategory: function (itemId, name, catalog) {
        if (!catalog || catalog.length === 0) return 'Sem Categoria';

        let current = null;

        // Buscar por ID ou nome
        if (itemId) {
            current = catalog.find(x => x.id === itemId);
        }
        if (!current && name) {
            current = catalog.find(x => x.nome.trim().toUpperCase() === name.trim().toUpperCase());
        }

        // Subir hierarquia até encontrar categoria
        if (current) {
            let safety = 0;
            while (current && current.parent_id && safety < 10) {
                const parent = catalog.find(x => x.id === current.parent_id);
                if (!parent) break;
                if (parent.tipo === 'CATEGORIA') return parent.nome;
                current = parent;
                safety++;
            }
        }

        return 'Geral';
    },

    /**
     * Popula filtro de categorias
     */
    populateCategoryFilter: function () {
        const set = new Set(this.data.map(d => d.categoria));
        const cats = Array.from(set).sort();

        const sel = document.getElementById('sel-filter-category');
        if (!sel) return;

        sel.innerHTML = `<option value="">Todas as Categorias</option>` +
            cats.map(c => `<option value="${c}">${c}</option>`).join('');
    },

    /**
     * Atualiza KPIs do dashboard
     */
    updateKPIs: function () {
        // Diesel S500
        const diesel = this.data.find(d => d.item_nome && d.item_nome.toUpperCase().includes('DIESEL S500'));
        const dieselQty = diesel ? parseFloat(diesel.saldo_atual || 0) : 0;

        const dieselLabel = document.getElementById('kpi-diesel-qty');
        const dieselBar = document.getElementById('kpi-diesel-bar');

        if (dieselLabel) dieselLabel.innerText = dieselQty.toLocaleString('pt-BR') + ' L';
        if (dieselBar) {
            const pct = Math.min(100, Math.max(0, (dieselQty / 5000) * 100));
            dieselBar.style.width = `${pct}%`;
        }

        // Capital Total e Alertas
        let totalVal = 0;
        let alertCount = 0;
        this.data.forEach(item => {
            const qtd = parseFloat(item.saldo_atual || 0);
            const custo = parseFloat(item.custo_medio || 0);
            if (qtd > 0) totalVal += (qtd * custo);
            if (qtd < 0 || (qtd > 0 && custo === 0)) alertCount++;
        });

        const totalLabel = document.getElementById('kpi-total-value');
        if (totalLabel) totalLabel.innerText = totalVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        const alertCard = document.getElementById('card-alerts');
        const alertNum = document.getElementById('alert-count');
        if (alertCard) {
            alertCard.style.display = alertCount > 0 ? 'flex' : 'none';
            if (alertNum) alertNum.innerText = alertCount;
        }
    },

    /**
     * Renderiza tabela de itens
     */
    renderTable: function (items) {
        const tbody = document.getElementById('estoque-table-body');
        if (!tbody) return;

        if (!items || items.length === 0) {
            tbody.innerHTML = `<tr><td colspan="7" style="text-align: center; padding: 40px; color: #9ca3af;">Nenhum item encontrado.</td></tr>`;
            return;
        }

        let html = '';
        items.forEach((item, index) => {
            const qtd = parseFloat(item.saldo_atual || 0);
            const custo = (Math.abs(qtd) < 0.001) ? 0 : parseFloat(item.custo_medio || 0);
            const total = qtd * custo;

            // Detectar problemas
            const hasNegativeStock = qtd < 0;
            const hasZeroCost = qtd > 0 && custo === 0;
            const hasProblem = hasNegativeStock || hasZeroCost;

            // Cores e estilos baseados em problema
            const bgClass = hasProblem ? '#fef2f2' : (index % 2 === 0 ? '#ffffff' : '#f9fafb');
            const textColor = hasProblem ? '#b91c1c' : '#374151';
            const catLabel = item.categoria || 'Geral';

            // Ícone de alerta
            const alertIcon = hasProblem ? '<i class="fas fa-exclamation-triangle" style="color: #f59e0b; margin-right: 6px;" title="Item com problema"></i>' : '';

            html += `
                <tr style="background-color: ${bgClass}; border-bottom: 1px solid #f3f4f6; color: ${textColor};">
                    <td style="padding: 6px 15px; font-weight: 500;">${alertIcon}${item.item_nome}</td>
                    <td style="padding: 6px 15px;"><span style="background:#e0f2fe; color:#0369a1; padding:2px 8px; border-radius:12px; font-size:0.7rem; font-weight:600;">${catLabel}</span></td>
                    <td style="padding: 6px 15px; text-align: center;"><span style="background: #e5e7eb; padding: 1px 6px; border-radius: 4px; font-size: 0.75rem; color: #4b5563;">${item.unidade || 'UN'}</span></td>
                    <td style="padding: 6px 15px; text-align: right; font-weight: 600; color: ${hasNegativeStock ? '#b91c1c' : '#374151'};">${qtd.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td style="padding: 6px 15px; text-align: right; color: ${hasZeroCost ? '#b91c1c' : '#6b7280'};">${custo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding: 6px 15px; text-align: right; font-weight: 700; color: ${hasProblem ? '#b91c1c' : '#111827'};">${total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td style="padding: 6px 15px; text-align: center;">
                        <button class="btn-icon-history" data-id="${item.id}" title="Ver Histórico" style="border:none; background:transparent; cursor:pointer; color:#9ca3af; margin-right: 8px;">
                            <i class="fas fa-history"></i>
                        </button>
                        <button class="btn-icon-adjust" data-id="${item.id}" title="Lançar Baixa Manual" style="border:none; background:transparent; cursor:pointer; color:#ef4444;">
                            <i class="fas fa-minus-circle"></i>
                        </button>
                    </td>
                </tr>
            `;
        });

        tbody.innerHTML = html;

        // Event listeners para botões da tabela
        tbody.querySelectorAll('.btn-icon-history').forEach(btn => {
            btn.addEventListener('click', () => {
                const id = btn.dataset.id;
                this.openTimelineModal(id);
            });
        });

        tbody.querySelectorAll('.btn-icon-adjust').forEach(btn => {
            btn.addEventListener('click', () => {
                const id = btn.dataset.id;
                this.openAjusteModal(id);
            });
        });
    },

    /**
     * Aplica filtros
     */
    applyFilters: function () {
        const searchInput = document.getElementById('estoque-search');
        const chkHide = document.getElementById('chk-hide-zero');
        const catFilter = document.getElementById('sel-filter-category');

        const term = searchInput ? searchInput.value.toLowerCase() : '';
        const hideZero = chkHide ? chkHide.checked : false;
        const catVal = catFilter ? catFilter.value : '';

        let filtered = this.data;

        if (term) {
            filtered = filtered.filter(item => item.item_nome.toLowerCase().includes(term));
        }

        if (hideZero) {
            filtered = filtered.filter(item => Math.abs(parseFloat(item.saldo_atual || 0)) > 0.001);
        }

        if (catVal) {
            filtered = filtered.filter(item => item.categoria === catVal);
        }

        this.renderTable(filtered);
    },

    /**
     * Setup event listeners
     */
    setupListeners: function () {
        const searchInput = document.getElementById('estoque-search');
        if (searchInput) {
            searchInput.addEventListener('input', () => this.applyFilters());
        }

        const chkHide = document.getElementById('chk-hide-zero');
        if (chkHide) {
            chkHide.addEventListener('change', () => this.applyFilters());
        }

        const selCat = document.getElementById('sel-filter-category');
        if (selCat) {
            selCat.addEventListener('change', () => this.applyFilters());
        }

        // Botão principal de ajuste manual
        const btnAjuste = document.getElementById('btn-ajuste-manual');
        if (btnAjuste) {
            btnAjuste.addEventListener('click', () => this.openAjusteModal());
        }
    },

    /**
     * Render modais
     */
    renderTimelineModal: function () {
        if (window.FazendaRP.Estoque.TimelineModal) {
            window.FazendaRP.Estoque.TimelineModal.render();
        }
    },

    renderAjusteModal: function () {
        if (window.FazendaRP.Estoque.AdjustmentModal) {
            window.FazendaRP.Estoque.AdjustmentModal.render();
        }
    },

    /**
     * Abre timeline para um item
     */
    openTimelineModal: function (estoqueId) {
        if (window.FazendaRP.Estoque.TimelineModal) {
            window.FazendaRP.Estoque.TimelineModal.open(estoqueId);
        } else {
            alert('Timeline modal não carregado');
        }
    },

    /**
     * Abre modal de ajuste
     */
    openAjusteModal: function (estoqueId) {
        if (window.FazendaRP.Estoque.AdjustmentModal) {
            window.FazendaRP.Estoque.AdjustmentModal.open(estoqueId);
        } else {
            alert('Adjustment modal não carregado');
        }
    }
};

console.log('✅ Estoque UI carregada (nova versão modular)');
